// these functions can be used without importing
// ref: https://gist.github.com/vielhuber/afcb99fdf23febffe0199649e19642cb
export default {

  //Clean an Array      
  cleanArray(myArray, callback) {
    return myArray.filter((e) => {
      return (e != false && e !== null && e !== " " && e !== "");
    });
  }, 
  //Split an Array into chunks
  splitArray(myArray, chunk_size, callback) {
    var index = 0;
    var tempArray = []; 
    for (index = 0; index < myArray.length; index += chunk_size) {
      myChunk = myArray.slice(index, index+chunk_size);
      tempArray.push(myChunk);
    }
    callback(tempArray);
  },
  //Remove duplicates from array of objects by attribute
  removeDuplicatesByAttribute(myArray, attribute) {
    let arrayWithoutDuplicates = myArray.filter((v,i,a)=>a.findIndex(t=>(t[attribute] === v[attribute]))===i)     
    return arrayWithoutDuplicates;
  },
  //format Number [10000 -> 10.000]   
  formatNumber(number) {
    if(number == undefined){
      return '-';
    }else {
      var formattedNumber = number.toLocaleString('de-DE',{minimumFractionDigits: 0, maximumFractionDigits: 0});
      return formattedNumber;
    }
    
  },
  //remove Element from an Array by attribute
  removeElement(element, removeArray, attribute) {
    var newArray = removeArray.filter(function( obj ) {
      return obj[attribute] !== element;
    });
    return newArray;
  },
  checkSelectedSizeForGraph(selected, allowedsize, graphdata){
    var nodoubles = this.checkGraphDoubles(selected, graphdata)
    console.log(nodoubles)
    if(selected.length > allowedsize || graphdata.length > allowedsize || nodoubles.length + graphdata.length > allowedsize){
      return false;
    }else{
      return true;
    }
  },

  getGraphColor: function(competitor){
    let competitors = [
                "titus",
                "planet sports",
                "skate deluxe",
                "skatepro"
            ];
    let colorCodes = [
                "rgba(150, 108, 66,0.8)",
                "rgba(235, 64, 52,0.8)",
                "rgba(251, 0, 255,0.8)",
                "rgba(251, 3, 255,0.8)"
            ];
    let arrayPosition = competitors.indexOf(competitor);
    if (arrayPosition === -1){
        var min = Math.ceil(0);
        var max = Math.floor(255);
        var math1 = Math.floor(Math.random() * (max - min)) + min;
        var math2 = Math.floor(Math.random() * (max - min)) + min;
        var math3 = Math.floor(Math.random() * (max - min)) + min;
        return   "rgb(" + math1 + ", " + math2 + ", " + math3 + ")"
    }
    else {
        return colorCodes[arrayPosition];
    }
  },
  getRainbowColor(graphdata){
    let colorCodes = [
      "rgba(0, 0, 255,0.8)",
      "rgba(255, 0, 0,0.8)",
      "rgba(255, 165, 0,0.8)",
      "rgba(0, 128, 0,0.8)",
      "rgba(238, 130, 238,0.8)",
      "rgba(75, 0, 130,0.8)",
      "rgba(52, 209, 160,0.8)",
      "rgba(255, 255, 0,0.8)",
      "rgba(108, 133, 154,0.8)",
      "rgba(169, 64, 103,0.8)",
    ];
    let graphObjects = [];
    for (let graphdataCount = 0; graphdataCount < graphdata.length; graphdataCount++) {
      let object = {
        color: graphdata[graphdataCount].borderColor
      }          
      graphObjects.push(object)
    }
    return colorCodes.filter(ar => !graphObjects.find(rm => (rm.color === ar) ));


  },
  checkGraphDoubles(selected, graphdata){
    // //console.log(selected)
    let graphObjects = [];
    for (let graphdataCount = 0; graphdataCount < graphdata.length; graphdataCount++) {
      let object = {
        keyword: graphdata[graphdataCount].label
      }          
      graphObjects.push(object)
    }
    // //console.log(graphObjects)
    return selected.filter(ar => !graphObjects.find(rm => (rm.keyword === ar.keyword) ));

  },
  setSettingsDownloadHeader(headers){
    localStorage.setItem("downloadheaders", JSON.stringify(headers));
  },
  deleteDownloadColumns(headers){
    let fields = [];
    for (let index = 0; index < headers.length; index++) {
      if(headers[index].text !== "Searchvolume Trend"){
        fields.push({ label: headers[index].text, value: headers[index].value } );
      }
    }
    return fields;
  },
  deleteDownloadAttributes(keywords){
    for (let index = 0; index < keywords.length; index++) {
      delete keywords[index].search_volumes;
    }
    return keywords;
  },
  transformDataForExcelDownload(keywords, headers){
    let monthArray = ["", "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

    for (let headerIndex = 3; headerIndex < headers.length; headerIndex++) {
      for (let keywordIndex = 0; keywordIndex < keywords.length; keywordIndex++) {
        let keywordKeys = Object.keys(keywords[keywordIndex]);
        if(keywordKeys.indexOf(headers[headerIndex].value) == -1 ){
          keywords[keywordIndex][headers[headerIndex].value] = ""
        }    
        let month = parseInt(headers[headerIndex].value.slice(-2));
        let year = headers[headerIndex].value.substring(0, headers[headerIndex].value.length - 2);
        keywords[keywordIndex][monthArray[month] + "-" + year] = keywords[keywordIndex][headers[headerIndex].value]
        delete keywords[keywordIndex][headers[headerIndex].value]

      }
    }
    return keywords
  },
  buildGraphObjects(rows, graphdata, startMonthFrontend, endMonthFrontend, initial) {
    // let monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let newGraphDatasets = []
    let rowsLength = 0
    if(initial){
      if(rows.length < 6){
        rowsLength = rows.length
      }else{
        rowsLength = 5
      }
    }else{
      rowsLength = rows.length
    }
    
    for (let rowIndex = 0; rowIndex < rowsLength ; rowIndex++) {
      console.log(rowIndex)

        let color = this.getRainbowColor(graphdata)
        let newData = {
          label: rows[rowIndex].keyword,
          backgroundColor:  "rgba(0, 0, 0, 0)",
          borderColor: color[0],
          pointBackgroundColor: 'white',
          borderWidth: 3.5,
          pointBorderColor: 'grey',
          data: []
        }

        console.log(startMonthFrontend)
        console.log(endMonthFrontend)

        //add missing months to new row
       
        let rankCounter = 1
        for (let startMonth = parseInt(startMonthFrontend); startMonth < parseInt(endMonthFrontend)+1; startMonth++) {


          let graphStartMonthBackwards = 0 
          // console.log(rowIndex)
          // console.log(rows[rowIndex].search_volumes)
          // console.log(rows[rowIndex].search_volumes.length-rankCounter)
          // console.log(startMonth)
          // console.log(endMonthFrontend)
          if(!rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter]){
            newData.data.push(null)
          }else{
            
            if(rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter].month <10){
              graphStartMonthBackwards = parseInt(rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter].year + "0"+ rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter].month)
            }else{
              graphStartMonthBackwards = parseInt(rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter].year + "" + rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter].month)
            }
            if(graphStartMonthBackwards == startMonth){
                newData.data.push(rows[rowIndex].search_volumes[rows[rowIndex].search_volumes.length-rankCounter].count)

                rankCounter++
            }else{
                newData.data.push(null)
            }
          }
          let startMonthString = []
          startMonthString.push(startMonth.toString())
          let lastDigits = parseInt(startMonthString[0].slice(-2))
          if( lastDigits % 12 == 0){
              startMonth = startMonth -12 +100
          }


        }
        graphdata.push(newData)
        // newGraphDatasets.unshift(newData);

    }
    console.log(newGraphDatasets)
    return newGraphDatasets
  }


  
};